import { DefaultTemplate } from "components/modal/templates";
import Datetime from "components/shared/form/datetime";
import Loader from "components/shared/loader";
import { getFirstPoint, getLastPoint } from "helpers/bidpoint";
import { dateTimeToView } from "helpers/date";
import { formatNumber } from "helpers/system";
import moment from "moment";
import React from "react";
import { getAxisLoadValues } from "sources/books/trackers";

export default class AxisLoadValuesModal extends DefaultTemplate {
    state = {
        dataLoaded: false,
        data: [],
        startedAt: null,
        endedAt: null,
    };

    componentDidMount() {
        const { bidPoints } = this.props.bid;
        const firstPoint = getFirstPoint(bidPoints);
        const startedAt = firstPoint.enteredAtByLogist || firstPoint.autoEnteredAt || firstPoint.planEnterDateOffset;
        const lastPoint = getLastPoint(bidPoints);
        const endedAt = lastPoint.loadUnloadedAtByLogist || lastPoint.autoLeavedAt || lastPoint.planLeaveDateOffset;

        this.setState({ startedAt: moment(startedAt).format(), endedAt: moment(endedAt).format() }, this.updateData);
    }

    updateData = () => {
        const { trackerId } = this.props;
        const { startedAt, endedAt } = this.state;
        const params = {
            fixedAt: {
                ge: new Date(startedAt),
                le: new Date(endedAt),
            },
        };
        getAxisLoadValues(trackerId, params).then((data) => this.setState({ data, dataLoaded: true }));
    };

    renderDateTime = (propName) => {
        return (
            <Datetime
                inPortal
                inputProps={{ name: propName }}
                onChange={({ value }) => this.setState({ [propName]: value })}
                value={this.state[propName]}
                wrapper="col-auto"
                bWrapper="d-inline-block"
            />
        );
    };

    renderData = () => {
        if (this.state.data.length === 0) {
            return <div className="text-center">Нет данных</div>;
        }
        return (
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Дата</th>
                        <th>Ось 1</th>
                        <th>Ось 2</th>
                        <th>Средний вес</th>
                        <th>Вес прицепа</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.data.map((item, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{dateTimeToView(item.fixedAt)}</td>
                            <td>{formatNumber(item.value)}</td>
                            <td>{formatNumber(item.secondaryValue)}</td>
                            <td>{formatNumber(item.averageValue)}</td>
                            <td>{formatNumber(item.trailerValue)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    renderBody = () => {
        if (!this.state.dataLoaded) {
            return <Loader />;
        }
        return (
            <div>
                <div className="row form-group">
                    <div className="col-auto col-form-label col-form-label-sm d-inline-block">Период:</div>
                    {this.renderDateTime("startedAt")}
                    <div className="col-auto col-form-label col-form-label-sm d-inline-block">&mdash;</div>
                    {this.renderDateTime("endedAt")}
                    <div className="btn btn-sm btn-brand" onClick={this.updateData}>
                        Обновить
                    </div>
                </div>
                {this.renderData()}
            </div>
        );
    };
}
